import styled from '@emotion/styled'

export const InputContainer = styled.div<{ isInvalidShowing?: boolean }>(({ isInvalidShowing, theme }) => ({
  position: 'relative',
  padding: '6px 8px',
  marginBottom: isInvalidShowing ? 10 : 16,
  borderBottom: `1px solid ${isInvalidShowing ? theme.colors.red2 : theme.colors.black}`,
}))
